/* eslint-disable prettier/prettier */
/* eslint-disable import/order */
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IDamageData } from '@bvi/api-interfaces/response/manage-base-data';
import { EditDamageForm } from './edit-form';
import { PaperModal } from '@bvi/common-components';
import { useDeleteDamageMutation } from '@bvi/admin-panel/entities/damage/api-slice';

interface IDamageActionMenuProperties {
  id: number;
  detail: IDamageData | null;
}

export const DamageActionMenu: FC<IDamageActionMenuProperties> = ({
  id,
  detail: _detail,
}) => {
  const { t } = useTranslation('translation');
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [deleteDamage] = useDeleteDamageMutation();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElement(null);
  };

  const handleEdit = () => {
    setEditModalOpen(true);
    handleClose();
  };

  const handleDelete = async () => {
    try {
      await deleteDamage(id).unwrap();
    } catch {
      // Error handling - mutation will show error state
    }
    handleClose();
  };

  return (
    <>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        size="small"
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorElement}
        keepMounted
        open={Boolean(anchorElement)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleEdit}>
          {t('manageList.actions.edit.caption')}
        </MenuItem>
        <MenuItem onClick={handleDelete}>
          {t('manageList.actions.remove.caption')}
        </MenuItem>
      </Menu>
      <PaperModal open={isEditModalOpen} onClose={() => setEditModalOpen(false)}>
        <EditDamageForm
          id={id}
          onSuccess={() => setEditModalOpen(false)}
        />
      </PaperModal>
    </>
  );
};

